import PBService from "@irati/utils/services"
import client, {MutationOptions} from "@irati/utils/services/apollo"
import botUseStateMutation from "./mutations/botUseState"

class TeamsBot extends PBService {
  async link(state: string, options: MutationOptions = {}): Promise<boolean> {
    await client.mutate({...options, mutation: botUseStateMutation, variables: {state}})

    return true
  }
}

const teamsBotService = new TeamsBot({errorHandlers: []})

export default teamsBotService
